<p-dialog closable="false" [(visible)]="visible" [draggable]="false" (onHide)="onHide()"
          [breakpoints]="{'2000px': '674px', '1900px': '674px', '1700px': '674px',
           '1400px': '674px', '960px': '70vw', '640px': '90vw'}"
          [modal]="true" [styleClass]="'alert'" [resizable]="false">

  <ng-template pTemplate="header">
    <div class="flex flex-column w-full">
      <div class="header">
        <h1 class="title font-bold title-blue font-22 color-header">{{ translations.title }}
          <span class="text-uppercase font-22"> {{ translations.titleComplemento }}</span>
        </h1>
        <svg-loader name="ico-normal-tramitfly-white" [containerClass]="'blue-dark font-18 color-header'"/>
      </div>
      <hr class="line-color mb-0"/>
    </div>
  </ng-template>

  <div class="main">
    <div class="content">
      <h5 class="font-22 title-blue font-normal mb-5 mx-0 font-roboto-condensed">{{ translations.subtitle }}</h5>
      <div class="list">
        @for (item of items; track item; let i = $index) {
          <div class="flex align-items-center font-18 mb-3">
            <span class="color-blue-2 font-medium mr-3">{{ i + 1 }}.</span>
            <i [class]="item.icon" class="mr-3 color-blue-2 font-medium font-18"></i>
            <div class="app-text-gray" [innerHTML]="item.html | safeResource : 'html'" >
            </div>
          </div>
        }
      </div>
    </div>
    <div class="flex justify-content-center align-items-center my-5">
      <button pButton type="button" class=" btn py-3 font-13"
              (click)="visible = false" [label]="translations.btnClose">
      </button>
    </div>
  </div>
</p-dialog>
